import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'

import { WidgetComponent } from '../../types/widgets.types'
import { WidgetWrapper } from '../WidgetWrapper'

export const TimeTrackingWidget: WidgetComponent = ({ ...widgetProps }) => {
  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_TIMETRACKING_APP_DEV_PATH,
    'timetracking',
    './TimeTrackingWidget',
    'timeTrackingApp'
  )

  // @ts-expect-error: dynamic import
  const { TimeTrackingWidget: TimeTrackingWidget } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : {
          TimeTrackingWidget: () => <></>
        }

  return (
    <WidgetWrapper {...widgetProps} isLoading={!isLoaded} hasFullView>
      <TimeTrackingWidget isInFullView={widgetProps.isInFullView} />
    </WidgetWrapper>
  )
}
